import "./ElectricWaterHeaterService.module.css";
import Header from "@/reusable_sections/Header";
import ElectricHeaterHero from "./sections/ElectricHeaterHero";
import ElectricBrands from "./sections/ElectricBrands";
import ElectricServices from "./sections/ElectricServices";
import ElectricHeaterFaq from "./sections/ElectricHeaterFaq";
import ElectricWaterHeaterCta from "./sections/ElectricWaterHeaterCta";
import Footer from "@/reusable_sections/Footer";
export default function ElectricWaterHeaterServicePage() {
  return <div>
      <Header />
      <ElectricHeaterHero />
      <ElectricBrands />
      <ElectricServices />
      <ElectricHeaterFaq />
      <ElectricWaterHeaterCta />
      <Footer />
    </div>;
}